var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c(_vm.servico.tipoTarifa,{ref:"tarifa",tag:"component",attrs:{"servico":_vm.servico,"fornecedorPublicID":this.fornecedorPublicID,"servico_autorizado":_vm.servico_autorizado},on:{"edit":_vm.edit,"save":_vm.save,"deleteItem":_vm.deleteItem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }